const path = `/assets/images`;

//login page

export const mahindralogobeam = `${path}/mahindralogobeam.png`;
export const mahindralogobeamwhite = `${path}/mahindralogobeamwhite.png`;
export const mahindralogored = `${path}/mahindralogored.png`;
export const mkisanlogo = `${path}/Mkisan.png`;
export const mkisanFavicon = `${path}/mkisanFavicon.png`;
export const login_background = `${path}/Background.png`;
export const login_patch = `${path}/login patch2.png`;

//sidebar

export const profile = `${path}/Profile.png`;
export const logout = `${path}/logout.png`;
export const settings = `${path}/settings.png`;
export const sb1 = `${path}/sb-1.png`;
export const sb2 = `${path}/sb-2.png`;
export const sb4 = `${path}/Bookmark_White.png`;
export const sb5 = `${path}/sb-4.png`;
export const badge1 = `${path}/Contributor.png`;
export const badge2 = `${path}/Enthusiast.png`;
export const badge3 = `${path}/Enabler.png`;
export const badge4 = `${path}/Illuminator.png`;
export const badge5 = `${path}/Insight Guru.png`;
export const down_arrow = `${path}/downArrow.png`;

export const bookmarks_sb = `${path}/Bookmarks_sb.png`;
export const dashboard_sb = `${path}/Dashboard_sb.png`;
export const forem_sb = `${path}/Forem_sb.png`;
export const guidelines_sb = `${path}/Guidelines_sb.png`;
export const knowledge_sb = `${path}/Knowledge_sb.png`;
export const usefullinks_sb = `${path}/Usefullinks_sb.png`;
export const my_answers = `${path}/My answers.png`;
export const my_questions = `${path}/My Questions.png`;
export const my_knowledge = `${path}/My knowledge.png`;
export const gallery_sb = `${path}/gallery.png`;
export const folder_gallery = `${path}/folder.png`;
//header

export const mahindra_white = `${path}/Mahindra_Logo.png`;
export const mkisan_red = `${path}/mKisan_Red.png`;
export const home = `${path}/Home.png`;
export const home_active = `${path}/Home_Active.png`;
export const ques_for_me = `${path}/Que_For_Me.png`;
export const ques_for_me_active = `${path}/Que_For_Me_Active.png`;
export const ask_expert = `${path}/Ask_Exper.png`;
export const ask_expert_active = `${path}/Ask_Exper_Active.png`;
export const create_knowledge = `${path}/Cre_knowl.png`;
export const create_knowledge_active = `${path}/Cre_knowl_Active.png`;
export const calender = `${path}/Cal.png`;
export const calender_active = `${path}/Cal_Active.png`;
export const notification = `${path}/Notification.png`;
export const toggle_btn = `${path}/Togg.png`;

export const docs_upload = `${path}/Document upload.png`;
export const audio_rec = `${path}/Audio.png`;
export const video_rec = `${path}/Video.png`;

//home

export const bookmark_black = `${path}/Bookmark_Black.png`;
export const bookmark_filled = `${path}/bookmark_filled.jpg`;
export const bookmark_red = `${path}/Bookmark_Red.png`;
export const comment = `${path}/Comment.png`;
export const dots = `${path}/001.png`;
export const dp = `${path}/dp.png`;
export const q_a_banner = `${path}/Q_A.png`;
export const knowledge_banner = `${path}/Arti.png`;
export const q_a_banner_red = `${path}/QA_Book.png`;
export const knowledge_banner_red = `${path}/St_Book.png`;
//export const like = `${path}/upvotegrey.png`;
export const like = `${path}/like.png`;
export const like_filled = `${path}/fill_like.png`;
export const search = `${path}/Search icon.png`;
export const search_menu = `${path}/Search knowledge icon.png`;
export const send = `${path}/sent.png`;

export const bookmark_question = `${path}/001_b.png`;
export const bookmark_question_filled = `${path}/001_r.png`;
export const bookmark_doc = `${path}/004_b.png`;
export const bookmark_doc_filled = `${path}/004_r.png`;
export const bookmark_audio = `${path}/002_b.png`;
export const bookmark_audio_filled = `${path}/002_r.png`;
export const bookmark_video = `${path}/003_b.png`;
export const bookmark_video_filled = `${path}/003_r.png`;

//Profile

export const del = `${path}/Trash icon.png`;
export const interests = `${path}/Intrest.png`;
export const interests_red = `${path}/Intrest icon.png`;
export const add_icon = `${path}/plus icon.png`;
export const expertise = `${path}/Experties.png`;

export const coming_soon = `${path}/Under Construction.png`;
export const thumbnail = `${path}/au.png`;

//knowledge

export const doc_upload = `${path}/Doc Upload.png`;
export const upload = `${path}/upload.png`;
export const audio = `${path}/audio2.png`;
export const video = `${path}/video2.png`;
export const ask__expert = `${path}/ask expert.png`;
export const edit = `${path}/edit.png`;
export const audio_thumbnail = `${path}/audio-thumbnail.png`;

export const expert_badge_icon = `${path}/expertBadge.png`;
export const expert_badge = `${path}/Expert badge for comments.png`;

export const ic_broken_image = `${path}/ic_broken_image.png`;
export const ic_loading_image = `${path}/ic_loading_image.png`;

export const pdf_images = `${path}/PDF_image.jpg`;
export const doc_image = `${path}/doc_image.png`;
